const API_URL = 'https://light-dash.serveminecraft.net/api';

export const api = {
    checkStatus: async () => fetch(`${API_URL}/status`).then(r => r.json()),
    login: async (password) => fetch(`${API_URL}/login`, {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ password })
    }).then(r => r.ok),
    getFiles: async () => fetch(`${API_URL}/files`).then(r => r.json()),
    getFile: async (id) => fetch(`${API_URL}/files/${id}`).then(r => r.json()),
    saveFile: async (id, content) => fetch(`${API_URL}/files/${id}`, {
        method: 'PUT', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ content })
    }).then(r => r.json())
};